import './style.css'

function Footer() {
  return (
    <footer className="footer">
      <p>
        Made with{' '}
        <span role="img" aria-label="heart">
          ❤️
        </span>{' '}
        by{' '}
        <a
          href="https://www.linkedin.com/in/amal-rajan-7b630913a/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Amal
        </a>
      </p>
    </footer>
  )
}

export default Footer
